import styled from 'styled-components'

import {Container} from '~/components/general/container/Container'

export const TrendChartContainer = styled(Container)`
  position: absolute;
  height: 100%;
`
